module.exports = __webpack_public_path__ + "static/img/details-bg.5993448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/details-bg.png
// module id = +JcV
// module chunks = 1